import styled from "styled-components"

export const PressReleaseContainer = styled.div`
  padding: 80px 0;
  background-color: #c7e6f5;
  h1 {
    color: ${props => props.theme.colors.darkBlue};
    margin-bottom: 42px;
  }
  a {
    color: ${props => props.theme.colors.darkBlue};
    text-decoration: none;
  }
  .load__more-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .load__more {
      background-color: ${props => props.theme.colors.brightBlue};
      color: ${props => props.theme.colors.white};
      border: 2px solid ${props => props.theme.colors.brightBlue};
      padding: 12px 40px;
      font-weight: bold;
      transition: 0.3s ease;
      &:hover {
        background-color: transparent;
        color: ${props => props.theme.colors.brightBlue};
      }
    }
  }
`

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
`
export const PressReleaseCard = styled.div`
  background-color: ${props => props.theme.colors.white};
  transition: 0.3s ease;
  margin-bottom: 25px;
  &:hover {
    background-color: ${props => props.theme.colors.brightBlue};
    h5,
    p {
      color: ${props => props.theme.colors.white};
    }
  }
  min-height: 200px;
  padding: 20px;

  h5,
  p {
    transition: 0.3s ease;
  }

  h5 {
    line-height: 1.2;
    margin-bottom: 12px;
  }
  .date {
    font-size: 14px;
    margin-bottom: 15px;
  }
`
